import { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { useModalNavigation } from "@/hooks/useModalNavigation";

export interface ModalProps {
  /**
   * Whether the modal is open
   */
  open?: boolean;
  /**
   * Title of the modal
   */
  title?: string;
  /**
   * Description/subtitle of the modal
   */
  description?: string;
  /**
   * Modal content
   */
  children: ReactNode;
  /**
   * Callback when modal should close
   */
  onClose?: () => void;
  /**
   * Custom CSS class for the modal content
   */
  className?: string;
  /**
   * Whether to show header (title/description)
   */
  showHeader?: boolean;
}

export const Modal = ({
  open = true,
  title,
  description,
  children,
  onClose,
  className = "sm:max-w-md",
  showHeader = true,
}: ModalProps) => {
  const { closeModal } = useModalNavigation();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      closeModal();
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => handleClose()}>
      <DialogContent className={className}>
        {showHeader && (title || description) && (
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};
